import { directive } from 'vue3-click-away'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  nuxtApp.vueApp.directive('click-away', directive as any)
})
